export default {"src":"/_next/static/media/mangrove.1570124d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};